const NAV_THEME_STORAGE_KEY = 'app_nav_theme';

export const syncDocumentTheme = (theme: 'light' | 'realDark') => {
  if (typeof document === 'undefined') return;

  const mode = theme === 'realDark' ? 'dark' : 'light';
  document.documentElement.dataset.theme = mode;
  document.documentElement.style.colorScheme = mode;
};

export const saveNavTheme = (theme: 'light' | 'realDark') => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(NAV_THEME_STORAGE_KEY, theme);
};
